import React from "react";
import { useForm } from "react-hook-form";
import { Input } from "@/components/ui/input";
import { Forms } from "@/types/form";
import { useFormListener } from "@/hooks/form/useFormListener";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "../../ui/form";
import { zodResolver } from "@hookform/resolvers/zod";
import schemas from "@/utils/schemas";
import { useSubmit } from "react-router-dom";

interface Props {
  user: Forms["VendorUser"];
}

const Profile: React.FC<Props> = ({ user }) => {
  const form = useForm<Forms["VendorUser"]>({
    resolver: zodResolver(schemas.vendor_user),
    defaultValues: {
      first_name: user?.first_name ?? "",
      last_name: user?.last_name ?? "",
      email: user?.email ?? "",
      role: user?.role ?? undefined,
    },
  });

  const {
    control,
    handleSubmit,
    formState: { isDirty, isSubmitting },
  } = form;

  useFormListener("form-vendor-profile", isDirty, isSubmitting);

  const onSubmit = useSubmit();

  return (
    <Form {...form}>
      <form
        onSubmit={handleSubmit(async (data) => await onSubmit(data))}
        id="form-vendor-profile"
        className="form-container mt-5 flex flex-col gap-5 "
      >
        <FormField
          control={control}
          name="first_name"
          render={({ field }) => (
            <FormItem>
              <FormLabel>First Name</FormLabel>
              <FormControl>
                <Input
                  {...field}
                  id="first_name"
                  type="text"
                  placeholder="First Name"
                  disabled
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={control}
          name="last_name"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Last Name</FormLabel>
              <FormControl>
                <Input
                  {...field}
                  id="last_name"
                  type="text"
                  placeholder="Last Name"
                  disabled
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Email</FormLabel>
              <FormControl>
                <Input
                  {...field}
                  id="email"
                  type="email"
                  placeholder="Email"
                  disabled
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        {/* <FormField
          control={control}
          name="role"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Role</FormLabel>
              <Select onValueChange={field.onChange} defaultValue={field.value}>
                <FormControl>
                  <SelectTrigger className="w-full">
                    <SelectValue placeholder="Select a role" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  {SELECT_ITEMS.roles.map((role) => (
                    <SelectItem key={role.value} value={role.value}>
                      {role.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>
          )}
        /> */}
      </form>
    </Form>
  );
};

export default Profile;
